import { z } from 'zod/v4';

import { CommonSearchParamsSchema } from '@/shared/utils/schemas';

export const ReportingSearchParamsSchema = CommonSearchParamsSchema.extend({
  ordering: z.enum(['type', 'date_from']).optional().catch(undefined),
});

export type ReportingSearchParams = z.infer<typeof ReportingSearchParamsSchema>;
